<script setup lang="ts">
import TopActionRow from './TopActionRow.vue'
import RangeTopActionRow from './RangeTopActionRow.vue'
import HeaderRow from './HeaderRow.vue'
import MonthPicker from './MonthPicker.vue'
import YearPicker from './YearPicker.vue'

const {
  months,
  years,
  month,
  year,
  customProps,
} = defineProps<{
  months: { value: number; text: string }[]
  years: { value: number; text: string }[]
  month: number
  year: number
  customProps?: {
    headingTitle?: string
    isRangePicker?: boolean
    rangeStep?: 'start' | 'end'
    startRangeTitle?: string
    endRangeTitle?: string
  }
}>()

const emit = defineEmits(['updateMonthYear'])

const { handleToggleOverlay } = inject('toggleOverlay')

const isMonthPickerVisible = ref(false)
const isYearPickerVisible = ref(false)

function toggleOverlay() {
  isYearPickerVisible.value = !isYearPickerVisible.value
  handleToggleOverlay(isMonthPickerVisible.value || isYearPickerVisible.value)
}
</script>

<template>
  <div class="month-year-picker">
    <TopActionRow
      v-if="!customProps.isRangePicker"
      :heading-title="customProps.headingTitle"
    />

    <RangeTopActionRow
      v-else
      :range-step="customProps.rangeStep"
      :start-range-title="customProps.startRangeTitle"
      :end-range-title="customProps.endRangeTitle"
    />

    <HeaderRow
      v-show="!isMonthPickerVisible && !isYearPickerVisible"
      :months="months"
      :month="month"
      :years="years"
      :year="year"
      @toggle-overlay="toggleOverlay"
      @update-month-year="(month, year) => emit('updateMonthYear', { instance: 0, month, year })"
    />

    <MonthPicker
      v-if="isMonthPickerVisible"
      :months="months"
      :month="month"
      :years="years"
      :year="year"
      @close-month-overlay="isMonthPickerVisible = false"
      @update:month="(month) => emit('updateMonthYear', { instance: 0, month, year })"
      @update:year="(year) => emit('updateMonthYear', { instance: 0, month, year })"
    />

    <YearPicker
      v-if="isYearPickerVisible"
      :year="year"
      :years="years"
      @update:year="(year) => emit('updateMonthYear', { instance: 0, month, year })"
      @open-month-overlay="isMonthPickerVisible = true"
      @close-year-overlay="isYearPickerVisible = false"
    />
  </div>
</template>
